"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TriggerButton = TriggerButton;
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _classes = require("../../common/classes");
var _colors = require("../../common/colors");
var _Icon = require("../icon/Icon");
var _iconNames = require("../icon/iconNames");
var _Spinner = require("../spinner/Spinner");
var _LabelTag = require("../tag/LabelTag");
var _IconButton = require("./IconButton");
var _excluded = ["active", "className", "clearable", "disabled", "fill", "onClear", "onClick", "icon", "intent", "large", "loading", "tagText", "text"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function TriggerButton(_ref) {
  var active = _ref.active,
    className = _ref.className,
    clearable = _ref.clearable,
    disabled = _ref.disabled,
    fill = _ref.fill,
    onClear = _ref.onClear,
    onClick = _ref.onClick,
    iconOverride = _ref.icon,
    intent = _ref.intent,
    large = _ref.large,
    loading = _ref.loading,
    tagText = _ref.tagText,
    text = _ref.text,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = (0, _classnames.default)(_defineProperty({}, _classes.Classes.ACTIVE, active), _defineProperty({}, _classes.Classes.FILL, fill), _defineProperty({}, _classes.Classes.intentClass(intent), intent), _defineProperty({}, _classes.Classes.LARGE, large), _classes.Classes.SELECT_BUTTON, className);
  var placeholder = props.placeholder || 'Please Select';
  var isClearable = clearable && !disabled && onClear;
  var triggerButtonClasses = (0, _classnames.default)(_defineProperty({}, _classes.Classes.TEXT_MUTED, !text), _classes.Classes.SELECT_BUTTON_TEXT);

  /**
   * Display a caret indicating whether we've got the menu open or not.
   * Replace it permanently with a custom icon if we supply one.
   * Replace it with a loading icon if we're loading.
   */
  var icon = /*#__PURE__*/React.createElement(_Icon.Icon8, {
    icon: active ? _iconNames.IconNames8.CARET_UP : _iconNames.IconNames8.CARET_DOWN
  });
  if (iconOverride) icon = /*#__PURE__*/React.createElement(_Icon.Icon8, {
    icon: iconOverride
  });
  if (loading) icon = /*#__PURE__*/React.createElement(_Spinner.Spinner, {
    small: true
  });

  /**
   * The button has a data-placeholder attribute so we can refer to it in system tests.
   * We can't put a button within a button so the clearable icon has to be in a span tag.
   */
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classes,
    disabled: disabled,
    "data-placeholder": placeholder,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: triggerButtonClasses
  }, tagText && /*#__PURE__*/React.createElement("span", {
    style: {
      marginRight: '8px'
    }
  }, /*#__PURE__*/React.createElement(_LabelTag.LabelTag, {
    color: _colors.ColorFamily.IVORY
  }, tagText)), text || placeholder), /*#__PURE__*/React.createElement("span", null, isClearable && /*#__PURE__*/React.createElement("span", {
    style: {
      marginRight: '8px'
    }
  }, /*#__PURE__*/React.createElement(_IconButton.IconButton24, {
    icon: _iconNames.IconNames8.CROSS,
    onClick: onClear,
    tagName: "span",
    "aria-label": "Clear"
  })), icon));
}